<template>
  <div class="add-dialog">
    <el-dialog title="新增用户" :visible.sync="addVisible"  :before-close="addCancel">
      <el-form :model="addForm" :rules="rules" ref="ruleForm">
        <el-form-item label="账号" :label-width="formLabelWidth" prop="userName">
          <el-col :span="10">
            <el-input  v-model="addForm.userName" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
          <el-col :span="10">
            <el-input  v-model="addForm.password" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="角色" :label-width="formLabelWidth" prop="roleId">
          <!-- <el-col :span="14"> -->
            <el-select style="width:50%" v-model="addForm.roleId" placeholder="请选择">
              <el-option
                v-for="item in roleOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
          </el-select>
          <!-- </el-col> -->
        
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-col :span="12">
            <el-input  v-model="addForm.realName" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="联系方式" :label-width="formLabelWidth">
          <el-col :span="12">
            <el-input  v-model="addForm.phone" autocomplete="off"></el-input>
          </el-col>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCancel">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    addVisible:{
      type:Boolean,
      default:  false
    },
    roleOption:{
      type: Array,
      default: []
    }
  },
  data () {
    return {
      addForm: {
        userName: '',
        password: '',
        roleId: '', 
        realName: "",
        phone: ''
      },
      options: [
        {
          id: 1,
          value: '超级管理员',
          label: '超级管理员'
        },
        {
          id: 2,
          value: '普通管理员',
          label: '普通管理员'
        },
      ],
      rules: {
        userName: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
          ],
        password: [
        { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        roleId: [
            { required: true, message: '请选择角色权限', trigger: 'change' }
          ],
      },
      formLabelWidth:'120px'
    }
  },
  methods: {
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //       if (valid) {
    //         alert('submit!');
    //       } else {
    //         console.log('error submit!!');
    //         return false;
    //       }
    //     });
    //   },
      addConfirm(){
        const _this = this
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            _this.$emit('addConfirm', _this.addForm)
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      addCancel(){
        this.$emit('addCancel', false)
      }
  }
}
</script>

<style lang="scss">
  .add-dialog{
    /deep/ .el-form{
      .el-input{
        width: 150px;
      }
    }
  }
</style>